import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  DynamicDialogConfig,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import { DialogSize } from '../../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { ZavisniTroskoviDialogComponent } from './zavisni-troskovi-dialog/zavisni-troskovi-dialog.component';
import { Subscription } from 'rxjs';
import { AlertService, RacunService } from '@kodit/core/services';
import { ZavisniTrosak } from '../neobradjen-racun-obrada-stavke-card/neobradjen-racun-obrada-stavke-card.component';

@Component({
  selector: 'kodit-zavisni-troskovi-card',
  templateUrl: './zavisni-troskovi-card.component.html',
  styleUrls: ['./zavisni-troskovi-card.component.scss'],
})
export class ZavisniTroskoviCardComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Dialog */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.MEDIUM_SMALL
  );

  /** Props */
  zavisniTroskovi: ZavisniTrosak[] = [];
  isPrekalkulisiDisabled = true;

  /** I/O */
  @Input() sefId: number | undefined;

  constructor(
    private _dialogService: DynamicDialogService,
    private _racunService: RacunService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this._subs.add(
      this._racunService.getZavisneTroskoveObservable.subscribe((res) => {
        this.zavisniTroskovi = res;
        this._getCanCalculateZavisneTroskove();
      })
    );

    this._subs.add(
      this._racunService.getStavkeArray.valueChanges.subscribe(() => {
        this._getCanCalculateZavisneTroskove();
      })
    );
  }

  openTroskoviDialog() {
    this.dialogConfig.header = 'Dodaj zavisne troškove';
    this.dialogConfig.hideFooter = true;
    this.dialogConfig.maximisable = false;
    this.dialogConfig.data = {
      sefId: this.sefId,
    };

    this._dialogService.open(ZavisniTroskoviDialogComponent, this.dialogConfig);
  }

  calculateZavisneTroskove() {
    this._racunService.calculateZavisneTroskove();
    this._alertService.addSuccessMsg('Zavisni troškovi prekalkulisani!');
  }

  removeAt(index: number): void {
    this._racunService.deleteZavisniTrosakByIndex(index);
  }

  private _getCanCalculateZavisneTroskove() {
    this.isPrekalkulisiDisabled =
      this.zavisniTroskovi.length === 0 ||
      !this._racunService.getCanCalculateZavisneTroskove();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
